import NGSeparator from 'src/styles/theme/components/NGSeparator';
import styled from 'styled-components';

export const StyledCookieSettings = styled.div`
	position: relative;
	display: flex;
	flex-direction: column;

	width: 100%;
	height: 100%;

	padding: 0px 3px;
	color: ${({ theme }) => theme.colors.white};
`;

export const NGSeparatorEx = styled(NGSeparator)`
	width: 20%;
	margin-left: auto;
	margin-right: auto;
`;

export const StyledSwitchContainer = styled.div`
	width: 100%;
	margin-bottom: ${({ theme }) => theme.spacing.xs};

	* {
		cursor: pointer;
	}
`;
